<template>
  <div class="mb-select-image">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        top: startGameConfig.mainImage.pos.y + 'px' || 0 + 'px',
        left: startGameConfig.mainImage.pos.x + 'px' || 0 + 'px',
        width: startGameConfig.mainImage.width + 'px' || 1920 + 'px',
        height: startGameConfig.mainImage.height + 'px' || 1080 + 'px',
      }"
    />
    <div :key="'mb-select-field' + index" v-for="(fieldToSelect, index) in startGameConfig.fields">
      <div
        @click="setImg(index, fieldToSelect.audio)"
        class="mb-selectable-field"
        :style="[
          {
            top: fieldToSelect.pos.y + 'px' || 0 + 'px',
            left: fieldToSelect.pos.x + 'px' || 0 + 'px',
            width: fieldToSelect.width + 'px' || 0 + 'px',
            height: fieldToSelect.height + 'px' || 0 + 'px',
            background: fieldToSelect.background,
          },
          fieldToSelect.cssStyle,
        ]"
      >
        <div style="width: 100%; height: 100%; position: relative">
          <img
            :key="'FieldImage-' + indexFieldImage"
            style="position: absolute"
            v-for="(fieldImage, indexFieldImage) in fieldToSelect.images"
            :src="giveMeImagePlease(fieldImage.src)"
            :style="[
              {
                top: fieldImage.pos.y + 'px' || 0 + 'px',
                left: fieldImage.pos.x + 'px' || 0 + 'px',
                width: fieldImage.width + 'px',
                height: fieldImage.height + 'px',
              },
            ]"
          />
          <div v-html="fieldToSelect.html"></div>
        </div>
      </div>
      <div
        class="mb-select-field-answer"
        v-if="(currentImg == index || visited.some((x) => x == index)) && fieldToSelect.text"
        :style="[
          {
            top: fieldToSelect.text.pos.y + 'px' || 0 + 'px',
            left: fieldToSelect.text.pos.x + 'px' || 0 + 'px',
            background: fieldToSelect.text.background,
            width: fieldToSelect.text.width + 'px',
            height: fieldToSelect.text.height + 'px',
          },
          fieldToSelect.text.cssStyle,
        ]"
      >
        <p v-if="fieldToSelect.text.text">{{ fieldToSelect.text.text }}</p>
      </div>
      <div class="mb-select-img-answer" v-if="currentImg == index || visited.some((x) => x == index)">
        <mb-audio-in-game
          :key="data.top + data.left + 'audio' + indexC"
          v-for="(data, indexC) in fieldToSelect.mbAudioItemData"
          :item-data="data"
        ></mb-audio-in-game>
      </div>
    </div>
    <div :key="'mb-select-img' + index" v-for="(imgToSelect, index) in startGameConfig.images">
      <transition name="img-fade">
        <img
          @click="setImg(index, imgToSelect.audio, imgToSelect.close)"
          class="mb-selectable-img"
          :src="giveMeImagePlease(imgToSelect.src)"
          v-if="!closeImage.some((x) => x == index)"
          :style="[
            {
              top: imgToSelect.pos.y + 'px' || 0 + 'px',
              left: imgToSelect.pos.x + 'px' || 0 + 'px',
              width: imgToSelect.width + 'px' || 0 + 'px',
              height: imgToSelect.height + 'px' || 0 + 'px',
            },
            imageSetStyle(currentImg, index, imgToSelect),
          ]"
        />
      </transition>
      <div
        style="width: 100%; height: 100%; position: relative"
        v-if="currentImg == index || visited.some((x) => x == index)"
      >
        <img
          :key="'FieldImageSel-' + indexFieldImageSele"
          style="position: absolute"
          v-for="(fieldImageSel, indexFieldImageSele) in imgToSelect.images"
          :src="giveMeImagePlease(fieldImageSel.src)"
          :style="[
            {
              top: fieldImageSel.pos.y + 'px' || 0 + 'px',
              left: fieldImageSel.pos.x + 'px' || 0 + 'px',
              width: fieldImageSel.width + 'px',
              height: fieldImageSel.height + 'px',
            },
          ]"
        />
        <div v-html="imgToSelect.html"></div>
      </div>
      <div
        class="mb-select-img-answer"
        v-if="(currentImg == index || visited.some((x) => x == index)) && imgToSelect.text"
        :style="[
          {
            top: imgToSelect.text.pos.y + 'px' || 0 + 'px',
            left: imgToSelect.text.pos.x + 'px' || 0 + 'px',
            background: imgToSelect.text.background,
            width: imgToSelect.text.width + 'px',
            height: imgToSelect.text.height + 'px',
          },
          imgToSelect.text.cssStyle,
        ]"
      >
        <p v-if="imgToSelect.text.text">{{ imgToSelect.text.text }}</p>
        <img
          v-if="currentImg == index || visited.some((x) => x == index)"
          class="mb-select-img-answer-img"
          :src="giveMeImagePlease(imgToSelect.image.src)"
          style="position: absolute"
          :style="[
            {
              top: imgToSelect.image.pos.y + 'px' || 0 + 'px',
              left: imgToSelect.image.pos.x + 'px' || 0 + 'px',
            },
            imgToSelect.image.cssStyle,
          ]"
        />
      </div>
      <img
        class="mb-selectable-img-img"
        v-if="(currentImg == index || visited.some((x) => x == index)) && imgToSelect.image"
        :src="giveMeImagePlease(imgToSelect.image.src)"
        :style="[
          {
            top: imgToSelect.image.pos.y + 'px' || 0 + 'px',
            left: imgToSelect.image.pos.x + 'px' || 0 + 'px',
            width: imgToSelect.image.width + 'px',
            height: imgToSelect.image.height + 'px',
          },
          imgToSelect.image.cssStyle,
        ]"
      />
      <div class="mb-select-img-answer" v-if="currentImg == index || visited.some((x) => x == index)">
        <mb-audio-in-game
          :key="data.top + data.left + 'audio' + index2"
          v-for="(data, index2) in imgToSelect.mbAudioItemData"
          :item-data="data"
        ></mb-audio-in-game>
      </div>
    </div>

    <div
      class="redirect"
      v-for="image in imageRedirect"
      :style="{ ...image.cssStyle }"
      @click="redirectToResource(image.routerPush, image.previousRoute)"
    >
      <p v-if="image.text">{{ image.text }}</p>
      <img class="redirect-image" :src="giveMeImagePlease(image.imgSrc)" :style="{ ...image.imageStyle }" />
    </div>

    <mb-audio-in-game
      :key="data.top + data.left + 'audio' + index"
      v-for="(data, index) in startGameConfig.mbAudioItemData"
      :item-data="data"
    ></mb-audio-in-game>
  </div>
</template>
<script>
import { Howler } from 'howler';
import defaultMixin from '../../mixins/defaultMixin';
import mbAudioInGame from '__mainSrcDir/components/MbAudioModal/MbAudioInGame';
export default {
  name: 'mb-select-image',
  components: { mbAudioInGame },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      currentImg: -1,
      visited: [],
      audio: null,
      status: false,
      canIPlay: true,
      closeImage: [],
      imageRedirect: [],
    };
  },
  created() {
    console.log('mbimagheselct');
  },
  beforeMount() {},
  mounted() {
    this.init();
  },
  methods: {
    closeImg(close, index) {
      if (close) {
        this.closeImage.push(index);
      }
    },
    checkGameAction() {
      return this.gameChecker();
    },
    gameChecker() {
      let gamePass = true;
      if (this.startGameConfig.fields) {
        for (let i = 0; i < this.startGameConfig.fields.length; i++) {
          if (!gamePass == false) {
            if (this.startGameConfig.fields[i].correct) {
              if (this.visited.some((x) => x == i)) {
                gamePass = true;
              } else {
                gamePass = false;
              }
            } else {
              if (this.visited.some((x) => x == i)) {
                gamePass = false;
              } else {
                gamePass = true;
              }
            }
          }
        }
      } else {
        for (let i = 0; i < this.startGameConfig.images.length; i++) {
          if (!gamePass == false) {
            if (this.startGameConfig.images[i].correct) {
              if (this.visited.some((x) => x == i)) {
                gamePass = true;
              } else {
                gamePass = false;
              }
            } else {
              if (this.visited.some((x) => x == i)) {
                gamePass = false;
              } else {
                gamePass = true;
              }
            }
          }
        }
      }

      return gamePass;
    },
    redirectToResource(path, prev) {
      // this.$store.commit('CHANGE_PREVIOUS_ROUTE', prev);
      console.log('this.route.name', this.$route);
      this.$router.replace({ path });
    },
    imageSetStyle(currentImg, index, imgToSelect) {
      if (
        (currentImg == index || this.visited.some((x) => x == index)) &&
        this.startGameConfig.imageHighlight != false
      ) {
        // console.log(index + ' : ' + currentImg);
        // console.log(this.startGameConfig.imageHighlight);
        return { filter: 'drop-shadow(0 0 40px ' + imgToSelect.imageHighlightColor + ')' };
      }
    },
    setAudioConfig(src, volume) {
      this.audio = new Howl({
        src: this.giveMeImagePlease(src),
        autoplay: false,
        loop: false,
        volume: volume || 1,
        onpause: () => {
          console.log('end');
        },
        onstop: () => {
          console.log('end');
        },
      });
      this.startAudio();
    },
    startAudio() {
      this.audio.play();
    },
    stopAudio() {
      this.audio.stop();
    },
    setImg(index, audio, close) {
      if (!this.visited.some((x) => x == index)) {
        if (this.canIPlay) {
          if (this.currentImg != -1 && this.audio) {
            this.stopAudio();
          }
          if (audio) {
            this.setAudioConfig(audio.src, audio.volume);
          }
          this.currentImg = index;
          if (this.startGameConfig.noClose) {
            this.visited.push(index);
            // this.closeImg(close, index);
          }
          this.closeImg(close, index);
          this.canIPlay = false;
          setTimeout(() => {
            this.canIPlay = true;
          }, 500);
        }
      } else {
        // console.log(index);
        this.visited.forEach((e, inElement) => {
          if (e == index) {
            // console.log(e + ' : ' + index);
            this.visited.splice(inElement, 1);
          }
        });
        // console.log(this.visited);
        this.currentImg = Math.floor(Math.random() * 10) - 20;
      }
      // console.log(this.gameChecker());
      if (this.gameChecker()) {
        this.$store.dispatch('checkGame');
      }
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    resetGameAction() {
      this.currentImg = -1;
      this.audio = null;
      this.visited = [];
      this.closeImage = [];
    },
    init() {
      if (this.startGameConfig.imageRedirect) this.imageRedirect = this.startGameConfig.imageRedirect;
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    toBase64(index) {
      let elem = this.$refs['signaturePad-' + index];
      return elem[0].saveSignature().data;
      //console.log(elem[0].saveSignature().data);
    },
  },
  destroyed() {
    if (this.currentImg != -1) {
      if (this.audio) {
        this.stopAudio();
      }
    }
  },
  computed: {
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 900px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.mb-select-image, .mb-select-field
  background-size: contain
  background-repeat: no-repeat
  position: relative
  top: $backgroundOffsetTop
  left: $backgroundOffsetLeft
  height: $backgroundHeight
  width: $backgroundWidth
  top: 50px
  .redirect
    position: absolute
    cursor: pointer
    .redirect-image
      position: relative
  .mb-selectable-img, .mb-selectable-field
    transition: .3s
    position: fixed
    top: 0
    left: 0
    max-height: 100%
    max-width: 100%
    cursor: pointer
  .select-it
    filter: drop-shadow(0 0 40px green)
  .mb-select-img-answer, .mb-select-field-answer, .mb-selectable-img-img
    position: fixed
    p
      margin: 0

.modal-fade-leave-active, .modal-fade-enter-active
  transition: all .1s linear
.modal-fade-leave-to, .modal-fade-enter
  transform: scale(1.5,1.5)
  opacity: 0
.img-fade-leave-active, .img-fade-enter-active
  transition: all .3s linear
.img-fade-leave-to, .img-fade-enter
  opacity: 0
</style>
